import axios from "@/utils/axios";

enum Api {
  match = "/system/api/open/lock/match",
  query = "/system/api/open/lock",
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace addLock {
  export interface matchForm {
    lockId: string | number;
  }
  export interface resData {
    lockId: string | number,
    lockMac: string
  }
}

// 查询门锁信息
export const getMac = (mac: string) => {
  return axios.http<addLock.resData>({
    url: Api.query + '/' + mac,
    headers: {
      isToken: false,
    },
    method: "get",
  });
};

// 门锁配对
export const matchMac  = (params: addLock.matchForm) => {
  // return axios.post(Api.match, params);
  return axios.http({
    url: Api.match,
    headers: {
      isToken: false,
    },
    method: "post",
    data: params
  });
};
